/**
 * ChatPanel.styles.ts
 *
 * Styles for ChatPanel component.
 */

import { HUD_Z_INDEX } from '../../../../config/ui/hudDefaults.config';
import { ACCENT } from '../../theme';

export const chatPanelStyles = {
  container: {
    width: 380,
    height: 232,
    backgroundColor: 'rgba(8, 10, 16, 0.55)',
    backdropFilter: 'blur(3px)',
    border: `1px solid ${ACCENT.brass}`,
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column' as const,
    pointerEvents: 'auto' as const,
    zIndex: HUD_Z_INDEX.panels,
    overflow: 'hidden',
    transition: 'opacity 0.25s ease',
    fontFamily: '\'Inter\', \'Roboto\', sans-serif',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.5)',
  },
  tabBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 6px',
    background: 'rgba(0, 0, 0, 0.35)',
    userSelect: 'none' as const,
  },
  dragGrip: {
    color: 'rgba(196, 164, 105, 0.5)',
    fontSize: '11px',
    padding: '0 2px',
    lineHeight: 1,
  },
  tab: (active: boolean) => ({
    padding: '3px 8px',
    fontSize: '11px',
    fontWeight: 600 as const,
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    background: active ? 'rgba(255, 255, 255, 0.14)' : 'transparent',
    color: active ? '#fff' : '#8a93a3',
  }),
  miniButton: {
    background: 'transparent',
    border: 'none',
    color: '#8a93a3',
    fontSize: '12px',
    padding: '2px 4px',
    cursor: 'pointer',
    lineHeight: 1,
  },
  pausedBadge: {
    color: '#e67e22',
    fontSize: '10px',
    marginRight: '4px',
  },
  messages: {
    flex: 1,
    overflowY: 'auto' as const,
    padding: '6px 10px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '2px',
    lineHeight: '1.45',
  },
  message: {
    display: 'flex',
    gap: '6px',
    alignItems: 'baseline',
    wordBreak: 'break-word' as const,
    textShadow: '0 1px 2px rgba(0,0,0,0.9)',
  },
  typeLabel: (color: string) => ({
    color,
    fontSize: '10px',
    fontWeight: 'bold',
    flexShrink: 0,
  }),
  sender: (color: string) => ({
    color,
    fontWeight: 'bold',
    flexShrink: 0,
  }),
  text: {
    color: '#e6ebf2',
  },
  inputContainer: {
    display: 'flex',
    padding: '6px 8px',
    borderTop: '1px solid rgba(255, 255, 255, 0.06)',
    background: 'rgba(0, 0, 0, 0.25)',
  },
  input: {
    flex: 1,
    padding: '6px 10px',
    fontSize: '12.5px',
    background: 'rgba(255, 255, 255, 0.04)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '6px',
    color: 'white',
    outline: 'none',
  },
  collapsedPill: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: 'rgba(8, 10, 16, 0.85)',
    border: `1px solid ${ACCENT.brass}`,
    borderRadius: '16px',
    padding: '6px 12px',
    cursor: 'pointer',
    pointerEvents: 'auto' as const,
    zIndex: HUD_Z_INDEX.panels,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.55)',
    userSelect: 'none' as const,
    transition: 'transform 0.15s ease, border-color 0.15s ease',
  },
  collapsedLabel: {
    fontSize: '11px',
    fontWeight: 'bold' as const,
    color: '#c4a469',
    letterSpacing: '0.04em',
  },
  unreadBadge: {
    backgroundColor: '#e74c3c',
    color: '#ffffff',
    fontSize: '10px',
    fontWeight: 'bold' as const,
    borderRadius: '10px',
    padding: '1px 6px',
    lineHeight: 1.2,
    boxShadow: '0 0 6px rgba(231, 76, 60, 0.7)',
  },
};
